function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useRef, useContext, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButton, Dropdown, EmptySearch, PropertiesTree, KEYBOARD_KEYS } from '@keen.io/ui-core';
import { transparentize } from 'polished';
import { colors } from '@keen.io/colors';
import { useKeypress } from '@keen.io/react-hooks';
import { Container, DropdownContent, StyledPropertyItem } from './SearchableProperty.styles';
import PropertyGroup, { PropertyItem } from '../PropertyGroup';
import Property from '../Property';
import { SearchContext, AppContext } from '../../contexts';
import { Icon } from '@keen.io/icons';

var SearchableProperty = function SearchableProperty(_ref) {
  var property = _ref.property,
      isEditAllowed = _ref.isEditAllowed,
      properties = _ref.properties,
      onSelectProperty = _ref.onSelectProperty,
      onSearchProperties = _ref.onSearchProperties,
      onRemove = _ref.onRemove,
      onBlur = _ref.onBlur;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(!property),
      _useState2 = _slicedToArray(_useState, 2),
      editMode = _useState2[0],
      setEditMode = _useState2[1];

  var containerRef = useRef(null);

  var _useContext = useContext(SearchContext),
      expandTree = _useContext.expandTree,
      searchPropertiesPhrase = _useContext.searchPropertiesPhrase;

  var _useContext2 = useContext(AppContext),
      modalContainer = _useContext2.modalContainer;

  var isEmptySearch = searchPropertiesPhrase && properties && !Object.keys(properties).length;
  var outsideClick = useCallback(function (e) {
    if (editMode && containerRef.current && !containerRef.current.contains(e.target)) {
      setEditMode(false);
      if (onBlur) onBlur();
    }
  }, [editMode, containerRef, onBlur]);
  useEffect(function () {
    document.addEventListener('click', outsideClick);
    return function () {
      return document.removeEventListener('click', outsideClick);
    };
  }, [editMode, containerRef]);
  useEffect(function () {
    if (!isEditAllowed) setEditMode(false);
  }, [isEditAllowed, editMode]);
  var keyboardHandler = useCallback(function (_e, keyCode) {
    if (keyCode === KEYBOARD_KEYS.ESCAPE) {
      setEditMode(false);
      onBlur();
    }
  }, []);
  useKeypress({
    keyboardAction: keyboardHandler,
    handledKeys: [KEYBOARD_KEYS.ESCAPE],
    addEventListenerCondition: editMode,
    eventListenerDependencies: [editMode]
  });
  return React.createElement(Container, {
    ref: containerRef,
    "data-testid": "searchable-property",
    onClick: function onClick() {
      return !editMode && setEditMode(true);
    }
  }, React.createElement(PropertyGroup, {
    isActive: editMode
  }, React.createElement(StyledPropertyItem, {
    className: "drag-handle",
    onClick: function onClick() {
      return setEditMode(false);
    }
  }, React.createElement(Icon, {
    type: "drag",
    fill: colors.blue[100],
    width: 13
  })), React.createElement(PropertyItem, null, React.createElement(Property, {
    "data-testid": "searchable-property-placeholder",
    property: property,
    editMode: editMode,
    placeholder: t('query_creator_searchable_property.placeholder'),
    searchPlaceholder: t('query_creator_searchable_property.search_placeholder'),
    onEditInputChange: onSearchProperties
  })), React.createElement(StyledPropertyItem, null, React.createElement(ActionButton, {
    onClick: onRemove,
    action: "remove",
    borderRadius: "0 4px 4px 0",
    background: "transparent",
    backgroundHover: transparentize(0.85, colors.blue['100'])
  }))), React.createElement(Dropdown, {
    isOpen: editMode,
    fullWidth: false
  }, React.createElement(DropdownContent, null, isEmptySearch ? React.createElement(EmptySearch, {
    message: t('query_creator_searchable_property.empty_search_results')
  }) : React.createElement(PropertiesTree, {
    modalContainer: modalContainer,
    expanded: expandTree,
    activeProperty: property,
    properties: properties,
    onClick: function onClick(_e, property) {
      onSelectProperty(property);
      setEditMode(false);
    }
  }))));
};

export default SearchableProperty;